const ROUTER_CONFIG = {
  // common page
  'login': resolve => require(['../components/login/auto-login.vue'], resolve),
  'zhihuiLogin': resolve => require(['../components/login/zhihui-more-login.vue'], resolve),
  '404': resolve => require(['../components/error/404.vue'], resolve),
  // address book，产品简称：AB
  'AB_addressBook': resolve => require(['../pages/address-book/address-book.vue'], resolve),
  'AB_addressBookPersonDetails': resolve => require(['../pages/address-book/address-book-person-details.vue'], resolve),
  // 纪委系统，产品简称：JW
  'JW_formList': resolve => require(['../pages/JW-system/JW-formList.vue'], resolve),
  'JW_formDetailList': resolve => require(['../pages/JW-system/JW-formDetailList.vue'], resolve),
  'JW_formDetail': resolve => require(['../pages/JW-system/JW-formDetail.vue'], resolve),
  // 打卡签到，产品简称：CI
  'CI_checkIn': resolve => require(['../pages/check-in/check-in.vue'], resolve)
}

export default ROUTER_CONFIG



// WEBPACK FOOTER //
// ./src/router/router.config.js